import { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Loader2, ArrowLeft } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PaymentResultPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const isCancel = window.location.pathname.includes("cancel");
  const [status, setStatus] = useState(isCancel ? "cancelled" : "loading");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (isCancel || !sessionId) return;
    let attempts = 0;
    const poll = async () => {
      try {
        const r = await axios.get(`${API}/api/payments/status/${sessionId}`);
        setData(r.data);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        if (r.data.payment_status === "failed") { setStatus("failed"); return; }
        if (attempts < 10) { attempts++; setTimeout(poll, 2000); }
        else setStatus("timeout");
      } catch { setStatus("error"); }
    };
    poll();
  }, [sessionId, isCancel]);

  return (
    <div className="min-h-screen bg-[#0B0F19] flex items-center justify-center p-6">
      <div className="bg-[#151B2B] border border-[#2A3441] rounded-2xl p-8 max-w-md w-full text-center space-y-4" data-testid="payment-result">
        {status === "loading" && (
          <>
            <Loader2 className="h-12 w-12 text-[#0099CC] mx-auto animate-spin" />
            <h1 className="text-xl font-bold text-white">Verification du paiement...</h1>
            <p className="text-[#64748b] text-sm">Veuillez patienter quelques instants.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="h-16 w-16 text-[#10B981] mx-auto" />
            <h1 className="text-xl font-bold text-white">Paiement reussi !</h1>
            <p className="text-[#94A3B8]">Votre billet <strong className="text-white">{data?.ticket_name}</strong> a ete confirme.</p>
            <p className="text-[#64748b] text-sm">Vous recevrez un email de confirmation avec votre QR code d'acces.</p>
          </>
        )}
        {(status === "cancelled" || isCancel) && (
          <>
            <XCircle className="h-16 w-16 text-[#F59E0B] mx-auto" />
            <h1 className="text-xl font-bold text-white">Paiement annule</h1>
            <p className="text-[#94A3B8]">Votre paiement a ete annule. Aucun montant n'a ete debite.</p>
          </>
        )}
        {(status === "failed" || status === "error" || status === "timeout") && (
          <>
            <XCircle className="h-16 w-16 text-red-400 mx-auto" />
            <h1 className="text-xl font-bold text-white">Erreur de paiement</h1>
            <p className="text-[#94A3B8]">Une erreur est survenue. Veuillez reessayer ou contacter le support.</p>
          </>
        )}
        <div className="pt-4">
          <Link to="/evenements" className="inline-flex items-center gap-2 text-[#0099CC] hover:text-white text-sm transition-colors">
            <ArrowLeft className="h-4 w-4" /> Retour aux evenements
          </Link>
        </div>
      </div>
    </div>
  );
}
